/** MeSH disease class names used in gene GTP profiles (26.3). */
export const GTP_MESH_CLASSES = [
  'Infections',
  'Neoplasms',
  'Musculoskeletal Diseases',
  'Digestive System Diseases',
  'Stomatognathic Diseases',
  'Respiratory Tract Diseases',
  'Otorhinolaryngologic Diseases',
  'Nervous System Diseases',
  'Eye Diseases',
  'Urogenital Diseases',
  'Cardiovascular Diseases',
  'Hemic and Lymphatic Diseases',
  'Congenital, Hereditary, and Neonatal Diseases and Abnormalities',
  'Skin and Connective Tissue Diseases',
  'Nutritional and Metabolic Diseases',
  'Endocrine System Diseases',
  'Immune System Diseases',
  'Disorders of Environmental Origin',
  'Pathological Conditions, Signs and Symptoms',
  'Chemically-Induced Disorders',
  'Behavior and Behavior Mechanisms',
  'Psychological Phenomena',
  'Mental Disorders',
] as const;

export const GTP_PLOT_EXCLUDED_CLASSES = ['Disorders of Environmental Origin'] as const;

export const GTP_CHART_MESH_CLASSES = GTP_MESH_CLASSES.filter(
  name => !(GTP_PLOT_EXCLUDED_CLASSES as readonly string[]).includes(name),
);
